import React, {useEffect, useState} from 'react'
import axios from "axios";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

// Карточка Спикера
const SpeakerOldCard = ({ speaker }) => {
    return (
        <div
            className="bg-white flex flex-col rounded-t-2xl items-center relative"
            style={{ boxShadow: "rgb(234, 234, 234) 0px 0px 20px 6px, rgb(188 182 182) 0px 0px 6px 2px" }}
        >
            {/* === TOP IMAGE BLOCK === */}
            <div className="overflow-hidden rounded-t-2xl relative">
                <img
                    className="mx-auto w-full h-auto transition duration-[400ms] wp-post-image"
                    src={speaker.acf.sm_image}
                    alt={speaker.post_title}
                />
            </div>

            <div className="relative sm:px-4 px-2 sm:py-4 py-4 pt-0">
                <div className="relative sm:-mt-[45px] -mt-[25px] mb-3 z-[9] sm:w-[94px] sm:h-[94px] w-[64px] h-[64px]
                    flex rounded-full justify-center bg-white p-3 shadow-lg mx-auto
                    after:absolute sm:after:left-[5px] sm:after:top-[5px]
                    after:left-[2px] after:top-[2px]
                    after:border after:border-black
                    sm:after:w-[84px] sm:after:h-[84px]
                    after:w-[60px] after:h-[60px] after:rounded-full"
                >
                    {speaker.acf.logo && (
                        <img
                            src={speaker.acf.logo}
                            alt="Logo"
                            className="object-contain block w-full max-w-[50px]"
                            style={{ width: speaker.acf.logo_mw + "px" }}
                        />
                    )}
                </div>

                <h3 className="sm:text-lg mb-2 font-semibold text-center text-[#151515]">
                    {speaker.post_title}
                </h3>
                <p className="sm:text-sm text-[13px] max-sm:leading-[16px] text-center text-[#505050]">
                    {speaker.acf.position}
                </p>
            </div>
        </div>
    );
};


// Основной компонент для отображения спикеров
const EventOldSpeakersBase = () => {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/3729?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    let speacersData = post.speacers

    return (
        <>
            {speacersData && speacersData.length > 0 ? (
                <section className="pb-28 relative" id="speacers">
                    <div className="container max-w-screen-xl sm:px-4 w-[90%] sm:w-full mx-auto z-30 relative">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="font-bold uppercase text-3xl text-center text-[#000] mb-8
                                sm:text-4xl md:mb-[75px] lg:text-[60px]">Спікери 2025</h2>
                        </ScrollAnimation>
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 sm:gap-x-6 gap-x-3 gap-y-6">
                            {speacersData.map((speaker, index) => (
                                <SpeakerOldCard
                                    key={index}
                                    speaker={speaker} />
                            ))}
                        </div>
                    </div>

                </section>
            ) : null}
        </>
    );
};


export default EventOldSpeakersBase;
